// PDP rating summary links scroll down to the Bazaarvoice reviews widget. The
// widget is an app block in an Apps section, so there is no stable anchor id
// for the href to target; the link finds the widget host instead. Delegated
// from document so links re-rendered by the theme editor keep working.

const REVIEWS_SELECTOR = '[data-bv-show="reviews"]';

const scrollToReviews = (event) => {
  if (!event.target.closest('[data-reviews-link]')) return;

  const reviewsEl = document.querySelector(REVIEWS_SELECTOR);
  if (!reviewsEl) return;

  event.preventDefault();
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  reviewsEl.scrollIntoView({ behavior: isReducedMotion ? 'auto' : 'smooth' });
};

const initReviewsLink = () => {
  document.addEventListener('click', scrollToReviews);
};

export default initReviewsLink;
